import React from "react";
import { Link } from "react-router-dom";

export default function FederalPartnersSection({ api }) {
  const track = "federal-partners";
  const t = api?.t || {};
  const lang = api?.lang || "en";
  const cfg = t?.programTracks?.federalPartners || {};

  const returnTo = "/?noIntro=1#federal-partners-intake";

  const heading = cfg.heading || "Prime Opportunities & Contracting Readiness";
  const startIntake = cfg.startIntake || "Start intake";
  const blurb = cfg.blurb || "Learn the steps to become vendor-ready and compete for federal, state, and local opportunities. WOW50/50 supports capability statements, compliance awareness, and prime/sub relationship readiness (not certification).";
  const helpTitle = cfg.helpTitle || "How we can help";
  const helpBullets = Array.isArray(cfg.helpBullets) && cfg.helpBullets.length ? cfg.helpBullets : ["Vendor readiness basics (capability statement, NAICS, differentiators).", "Prime–sub matchmaking support and partnership outreach.", "SAM.gov / compliance awareness guidance (education, not certification).", "Subcontracting readiness (pricing, documentation, performance narrative).", "Referral routing to local procurement and OSDBU resources."];
  const trackLabel = cfg.trackLabel || "Federal Partners";
  const partnersTitle = cfg.partnersTitle || "For primes, agencies & ecosystem partners";
  const partnersBody1 = cfg.partnersBody1 || "We help small businesses get organized and ready for real opportunities with clear next steps and compliant routing.";
  const partnersBody2 = cfg.partnersBody2 || "Partner with WOW50/50 to expand subcontractor pipelines and improve readiness outcomes.";

  const options = Array.isArray(cfg.options) && cfg.options.length
    ? cfg.options
    : [
        { id: "vendor-ready", label: "Vendor readiness basics" },
                { id: "capability", label: "Capability statement support" },
                { id: "federal-market-entry", label: "Subcontracting / market entry" },
                { id: "sam", label: "SAM.gov / compliance awareness" },
                { id: "partnerships", label: "Prime partner outreach" }
      ];

  return (
    <section id="federal-partners" className="scroll-mt-24 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
          {heading}
        </h2>

        <Link
          to={`/intake?track=${encodeURIComponent(track)}&return=${encodeURIComponent(returnTo)}&lang=${encodeURIComponent(lang)}`}
          className="ml-auto inline-flex items-center justify-center rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-2 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15 transition"
        >
          {startIntake}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
          {blurb}
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          <div id="federal-partners-intake" className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{helpTitle}</div>
            <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
              {helpBullets.map((b, idx) => (
                <li key={idx}>{b}</li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{partnersTitle}</div>
            <div className="mt-2 text-sm text-slate-200 space-y-2">
              <p>{partnersBody1}</p>
              <p>{partnersBody2}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div className="mt-6 rounded-2xl border border-slate-800 bg-[#010916]/70 p-4">
        <div className="text-sm font-semibold text-slate-100">Member Intake (required)</div>
        <p className="mt-1 text-xs text-slate-300">
          To request personalized support under this program, you must be an active WOW50/50 member and logged in.
        </p>
        <div className="mt-3">
          <Link
            to={"/intake?track=" + encodeURIComponent(track)}
            className="inline-flex items-center justify-center rounded-xl border border-cyan-400/40 bg-cyan-500/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15"
          >
            Go to Member Intake
          </Link>
        </div>
      </div>
</section>
  );
}
